import { randRecentDate } from '@ngneat/falso'
import { Model, Factory, belongsTo } from 'miragejs'

export const model = Model.extend({
  invoice: belongsTo('invoice'),
})

export const factory = Factory.extend({
  invoice_prefix() {
    return ''
  },
  year() {
    return randRecentDate().getFullYear()
  },
})
